import * as React from 'react';
import Button from '../button';
export function OkButton(props) {
    return <Button size="small" type="primary" {...props}/>;
}
export function CancelButton(props) {
    return <Button size="small" {...props}/>;
}
